function getDisplayName(metricKey) {
  const nameMap = {
    systolic: "Systolic BP",
    diastolic: "Diastolic BP",
    bpm: "Heart Rate",
    weight_lbs: "Weight",
    spo2: "Oxygen Saturation",
    celsius: "Temperature",
  };
  return nameMap[metricKey] || metricKey;
}

function getDisplayTitle(config) {
  if (config.title) {
    return config.title;
  }

  return "Dynamic Program";
}

export default function convertConfig(newConfig) {
  if (!newConfig?.alerts) {
    return null;
  }

  const measures = [];

  Object.entries(newConfig.alerts).forEach(([metricKey, metricConfig]) => {
    const measure = {
      type: getDisplayName(metricKey),
      redAlert: [],
      yellowAlert: [],
    };

    if (metricConfig.red_alert && Array.isArray(metricConfig.red_alert)) {
      metricConfig.red_alert.forEach((alert) => {
        measure.redAlert.push(alert.message.trim());
      });
    }

    if (metricConfig.orange_alert && Array.isArray(metricConfig.orange_alert)) {
      metricConfig.orange_alert.forEach((alert) => {
        measure.yellowAlert.push(alert.message.trim());
      });
    }

    if (measure.redAlert.length > 0 || measure.yellowAlert.length > 0) {
      measures.push(measure);
    }
  });

  const result = {
    title: getDisplayTitle(newConfig),
    measure: measures,
  };
  return result;
}
